import LoadingSkeletonContainer from 'ComponentLibrary/src/atoms/LoadingSkeleton/LoadingSkeletonContainer'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export function OrderDetailsLoader() {
    return (
        <LoadingSkeletonContainer
            loadersPattern={[
                { count: 1, height: '40px' },
                { count: 6, height: '60px' },
            ]}
            gap={tokens.SizingSpacing200}
            padding={`${tokens.SizingSpacing200} 0`}
        />
    )
}
